var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.7629 5.15894C11.5439 5.15894 10.5557 6.14714 10.5557 7.36614V10.9846H6.77825C5.55924 10.9846 4.57104 11.9728 4.57104 13.1918V17.6395V29.011C4.57104 30.23 5.55925 31.2182 6.77825 31.2182H28.2232C29.4422 31.2182 30.4304 30.23 30.4304 29.011V17.6395V13.1918C30.4304 11.9728 29.4422 10.9846 28.2232 10.9846H24.4458V7.36614C24.4458 6.14714 23.4576 5.15894 22.2386 5.15894H12.7629ZM22.5539 12.8765V15.9331H24.4458V12.8765H28.2232C28.3974 12.8765 28.5386 13.0176 28.5386 13.1918V17.6395C28.5386 20.27 26.4061 22.4025 23.7755 22.4025H11.226C8.59541 22.4025 6.46294 20.27 6.46294 17.6395V13.1918C6.46294 13.0176 6.60411 12.8765 6.77825 12.8765H10.5557V15.9331H12.4476V12.8765H22.5539ZM22.5539 10.9846V7.36614C22.5539 7.192 22.4127 7.05083 22.2386 7.05083H12.7629C12.5888 7.05083 12.4476 7.192 12.4476 7.36614V10.9846H22.5539ZM11.226 24.2944C9.35894 24.2944 7.67149 23.5256 6.46294 22.2872V29.011C6.46294 29.1852 6.60411 29.3263 6.77825 29.3263H28.2232C28.3974 29.3263 28.5386 29.1852 28.5386 29.011V22.2872C27.33 23.5256 25.6425 24.2944 23.7755 24.2944H11.226Z",
  fill: "white"
});

function SvgJob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJob);
export default __webpack_public_path__ + "static/media/Job.b6552cf5.svg";
export { ForwardRef as ReactComponent };